// extracted by mini-css-extract-plugin
export default {"card":"styles_card__D66Bj","chartWrap":"styles_chartWrap__onKe4","chart":"styles_chart__VwAmQ","empty":"styles_empty__OxwoS"};